export default __webpack_public_path__ + "static/media/VID-20220612-WA0000.094b7039.mp4";